<template lang="pug">

  .lesson-test-slide-answers
    .lesson-test-slide-answers__header
      .lesson-test-slide-answers__title
        | Варианты ответа
      .lesson-test-slide-answers-types
        .lesson-test-slide-answers-types__checkbox(
          @click="setAnswersType(false)"
        )
          CheckboxBlock(
            :value="!isMultipleAnswers"
            :disabled="true"
            text="Один ответ"
          )
        .lesson-test-slide-answers-types__checkbox(
          @click="setAnswersType(true)"
        )
          CheckboxBlock(
            :value="isMultipleAnswers"
            :disabled="true"
            text="Несколько ответов"
            wrapperClass="-rect-"
          )

    transition-group.lesson-test-slide-answers__list(
      tag="div"
      name="list"
    )
      template(v-for="(answer, idx) in activeAnswers")
        AnswerItem(
          v-if="!answer.isDeleted" :key="answer.answerDeleteId"
          :isMultipleAnswers="isMultipleAnswers"
          :propAnswer="answer"
          :lastAnswer="idx === activeAnswers.length-1"
          @addAnswer="addAnswer"
          @deleteAnswer="deleteAnswer(idx)"
          @updateAnswer="updateAnswer($event, idx)"
        )

</template>

<script>
import _ from 'lodash';
import CheckboxBlock from '@/components/Form/Checkbox';
import AnswerItem from './AnswerItem';

export default {
  components: { CheckboxBlock, AnswerItem },
  props: ['propIsMultipleAnswers', 'propAnswers'],
  data() {
    return {
      isMultipleAnswers: undefined,
      emptyAnswer: {
        text: '',
        isCorrect: false,
        isDeleted: false,
        points: 0,
        answerDeleteId: 0,
        position: 0,
        numbers: {
          money: 0,
          deals: 0,
          romi: 0,
          nps: 0,
          analytics: 0,
          sales: 0,
          marketing: 0,
          team: 0
        }
      },
      answerDeleteId: 0,
      activeAnswers: [],
      answersToDelete: []
    };
  },
  watch: {
    isMultipleAnswers(curr, prev) {
      if (curr !== prev && prev !== undefined) {
        this.activeAnswers.forEach((answer, aIdx) => {
          if (answer.isCorrect) {
            this.activeAnswers[aIdx].isCorrect = false;
          }
        });

        this.$emit('updateAnswersType', curr);
        this.updateAnswers();
      }
    }
  },
  mounted() {
    this.setData();
  },
  methods: {
    setData() {
      this.activeAnswers = this.propAnswers.map(answer => {
        this.answerDeleteId++;
        answer.answerDeleteId = this.answerDeleteId;
        return answer;
      });

      this.addAnswer();
      this.isMultipleAnswers = this.propIsMultipleAnswers;
    },
    setAnswersType(val) {
      this.isMultipleAnswers = val;
    },
    deleteAnswer(idx) {
      if (
        idx !== this.activeAnswers.length - 1 &&
        this.activeAnswers.length !== 1
      ) {
        this.activeAnswers[idx].isDeleted = true;
        if (this.activeAnswers[idx].id) {
          this.answersToDelete.push(this.activeAnswers[idx]);
        }
        this.activeAnswers = this.activeAnswers.filter(
          answer => !answer.isDeleted
        );

        this.updateAnswers();
      }
    },
    addAnswer() {
      this.answerDeleteId++;

      const newAnswer = _.cloneDeep(this.emptyAnswer);
      newAnswer.answerDeleteId = this.answerDeleteId;
      this.activeAnswers.push(newAnswer);
      this.activeAnswers = [...this.activeAnswers];

      this.activeAnswers = this.activeAnswers.filter(
        answer => !answer.isDeleted
      );

      this.updateAnswers();
    },
    updateAnswer(answer, idx) {
      // Если разрешен всего один ответ, обнуляем остальные
      if (answer.isCorrect && !this.isMultipleAnswers) {
        this.activeAnswers.forEach((answer, aIdx) => {
          if (answer.isCorrect) {
            this.activeAnswers[aIdx].isCorrect = false;
          }
        });
      }

      this.activeAnswers[idx] = _.cloneDeep(answer);
      this.activeAnswers = [...this.activeAnswers];

      this.updateAnswers();
    },
    updateAnswers() {
      // убираем пустые в конце фильтром
      let newAnswers = _.cloneDeep(this.activeAnswers).filter(
        answer => answer.text
      );
      if (this.answersToDelete.length > 0) {
        newAnswers = [...newAnswers, ...this.answersToDelete];
      }

      this.$emit('updateAnswers', newAnswers);
    }
  }
};
</script>
